<template>
  <div class="bg-primary">
    <div class="login-container">
      <div class="image-container">
        <img :src="vinayagarImage" alt="Vinayagar">
      </div>
      <div class="form-container">
        <img :src="logoImage" alt="Sri Ganesh Tiles Logo" class="logo">
        <form @submit.prevent="handleLogin">
          <div class="form-group">
            <input
              type="text"
              class="form-input"
              placeholder="Username"
              v-model="username"
              required
            />
          </div>
          <div class="form-group">
            <input
              type="password"
              class="form-input"
              placeholder="Password"
              v-model="password"
              required
            />
          </div>
          <div class="form-group">
            <button type="submit" class="btn-login">Login</button>
          </div>
        </form>
        
      </div>
    </div>
  </div>
</template>

<script>
import baseURL from "@/api/config.js";
import { useToast } from 'vue-toastification';
export default {
  name: "LoginComponent",
  data() {
    return {
      username: "",
      password: "",
      vinayagarImage: require('@/assets/vinayagar.jpg'), // Adjust the path as needed
      logoImage: require('@/assets/designlogo.png') // Adjust the path as needed for your logo
    };
  },
  methods: {
    async handleLogin() {
    try {
        const response = await fetch(`${baseURL}/AdminLoginController/login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            username: this.username,
            password: this.password
          })
        });
        const data = await response.json();
        if (data.success) {
           this.toast = useToast();
            this.toast.success('Login successful');
          sessionStorage.setItem('authToken', data.token);
      // Redirect to Add_Tiles_Information
      this.$router.push({ name: 'Add_Tiles_Information' });
            
        } else {
            this.toast = useToast();
            this.toast.error(data.message);
        }
        
      } catch (error) {
        console.error("Login failed:", error);
        console.log('Login failed: ' + error.message);
      }
    }
  }
};
</script>


<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', sans-serif;
}

.bg-primary {
  background-color: #1a73e8; /* Updated background color */
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.login-container {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: flex;
  max-width: 900px;
  width: 100%;
}

.image-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f9f9f9;
  padding: 20px;
}

.image-container img {
  max-width: 100%;
  border-radius: 10px;
}

.form-container {
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center; /* Centering the logo */
}

.form-container .logo {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px; /* Space between logo and form */
}

.form-group {
  margin-bottom: 15px;
}

.form-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.form-input:focus {
  border-color: #1a73e8;
  outline: none;
}

.btn-login {
  width: 100%;
  padding: 10px;
  background-color: #1a73e8;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 16px;
  cursor: pointer;
}

.btn-login:hover {
  background-color: #0056b3;
}

.register-link {
  margin-top: 20px;
  font-size: 14px;
}

.register-link a {
  color: #1a73e8;
  text-decoration: none;
}

.register-link a:hover {
  text-decoration: underline;
}
</style>
